import { Component } from '@angular/core';

import { TranslatePipe } from '@recruitee/i18n';
import {
  DialogBodyComponent,
  DialogComponentI,
  DialogHeaderComponent,
  DialogRef,
  NewItemButtonComponent,
} from '@recruitee/user-interface';

import { CreateMode } from '../../requisitions.types';

type DialogResult = {
  mode: CreateMode;
};

@Component({
  selector: 'rt-requisitions-create-requisition-dialog',
  templateUrl: './create-requisition-dialog.component.html',
  styleUrls: ['./create-requisition-dialog.component.less'],
  standalone: true,
  imports: [DialogBodyComponent, NewItemButtonComponent, DialogHeaderComponent, TranslatePipe],
})
export class CreateRequisitionDialogComponent implements DialogComponentI<void, DialogResult> {
  constructor(private dialogRef: DialogRef) {}

  public createBlank() {
    this.dialogRef.close({ mode: CreateMode.Blank });
  }

  public createDuplicate() {
    this.dialogRef.close({ mode: CreateMode.Duplicate });
  }

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  public setDialogData(data: void, triggerUpdate: boolean): void {}
}
